
import React, { memo,useEffect,useState } from 'react';
import { Layout, Menu, Breadcrumb,Row, Col, Button, Table, Tag, Drawer, Form, Select, Input, Space, message, Modal, Switch } from 'antd';
import { EditOutlined, SendOutlined, DeleteOutlined,PlusOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import './style.scss'
import { useNavigate } from "react-router-dom";
import Colors from '../../assets/themes/colors';
import GlobalSider from '../../components/GlobalSider';
import { addDataWithToken, deleteDataWithToken, editDataWithToken, getDataWithToken } from '../../globalFunctions/api';
import GlobalHeader from '../../components/GlobalHeader';
const {Content} = Layout;
const { Column, ColumnGroup } = Table;
const { Option } = Select;
const {confirm} = Modal

const pageTitle = 'ادارة الجامعات';

const  MngUniversities = ()=> {
    const navigate = useNavigate();
    const [addUniversityForm] = Form.useForm()
    const [editUniversityForm] = Form.useForm()

    const [addUniversityVisible, setAddUniversityVisible] = useState(false);
    const [editUniversityVisible, setEditUniversityVisible] = useState(false);
    
    const [addLoading, setAddLoading] = useState(false);
    const [selectedUniversity, setSelectedUniversity] = useState(null)
    const [universityFormInfo, setUniversityFormInfo] = useState(null)
    const [universities, setUniversities] = useState([]);
    const [totalCount, setTotalCount] = useState(null);

    

    const handleTableChange = (pagination, filters, sorter) => {
        const{current,pageSize} = pagination 
        getUniversities(current,pageSize)
      };


      const onAddClose = () => {
        setAddUniversityVisible(false);
        setSelectedUniversity(null)
        addUniversityForm.resetFields()
        
      };

      const onEditClose = () => {
        setEditUniversityVisible(false);
        setSelectedUniversity(null)
        editUniversityForm.resetFields()
        
      };

   
   

      const getUniversities = (current=1,pageSize=25)=>{
        setAddLoading(true)
        getDataWithToken(`universities?fields[0]=title&fields[0]=active&pagination[pageSize]=${pageSize}&pagination[page]=${current}`,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setUniversities(result?.data);
            setTotalCount(result?.meta?.total)
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      const addUniversity = (data)=>{
        setAddLoading(true)
        addDataWithToken(`universities`,data,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            message?.success('تم اضافة الجامعة بنجاح');
            getUniversities();
            addUniversityForm?.resetFields();
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      function showDeleteConfirm(A_field_name,id) {
        confirm({
            title: `  هل انت متأكد انك تريد حذف  ( ${A_field_name} )  `,
            icon: <ExclamationCircleOutlined style={{color:'red'}} />,
            content: 'ملاحظة : البيانات المحذوفة لا يمكن استعادتها لاحقا',
            okText: 'نعم',
            okType: 'danger',
            cancelText: 'الغاء',
            width:480,
            style:{textAlign:'right'},
            onOk() {
                setAddLoading(true);
                deleteDataWithToken(`universities/${id}`,(err, result)=>{

                    const {error} = result
                    if(err){
                        message?.error('خطأ في الشبكة')
                    }else{
                        if(!error){
                            message?.success('تم حذف الجامعة بنجاح');
                            getUniversities();
                        }else{
                            console.log(error)
                            message?.error(error?.message)
                        }
                    
                    }
                })

            },
            onCancel() {
                console.log('Cancel');
            },
            });
        }   

        const prepareEdit = (data)=>{
            setSelectedUniversity(data)
            const newData = data
            editUniversityForm.setFieldsValue(newData)
            setEditUniversityVisible(true)
        }

        const editUniversity = (data)=>{
         
            setAddLoading(true);
            editDataWithToken(`universities/${selectedUniversity?.id}`,data,(err, result)=>{
                const {error} = result
                if(err){
                    message?.error('خطأ في الشبكة')
                }else{
                    if(!error){
                        message?.success('تم تعديل الجامعة بنجاح');
                        getUniversities();
                    }else{
                        console.log(error)
                        message?.error(error?.message)
                    }
                
                }
            })
          }


      useEffect(() => {
       getUniversities();
      }, [])
      
    
    
    return(
        <Layout className='mainContainer'>

            <Drawer
                    title="اضافة جامعة"
                    placement="left"
                    closable={false}
                    onClose={onAddClose}
                    visible={addUniversityVisible}
                    width={350}
                >
                <Form 
                    form={addUniversityForm} 
                    onFinish={addUniversity}
                    onValuesChange={(changedValues,allValues)=>{
                        setUniversityFormInfo(allValues);
                    }}
                    layout='vertical'
                >

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="title" 
                        label="اسم الجامعة"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة اسم الجامعة',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="اسم الجامعة"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    <Form.Item label="مفعل" name="active" valuePropName="checked" >
                        <Switch  />
                    </Form.Item>
                    
                    <Button  style={{backgroundColor:Colors.primary, borderWidth:0}}  type="primary"  icon={<SendOutlined />} onClick={()=>{addUniversityForm.submit()}} loading={false} >
                          ارسال الطلب
                    </Button>
                    
                </Form>

            </Drawer>


            <Drawer
                    title={`تعديل ${selectedUniversity?.title}`}
                    placement="left"
                    closable={false}
                    onClose={onEditClose}
                    visible={editUniversityVisible}
                    width={350}
                >
                <Form 
                    form={editUniversityForm} 
                    onFinish={editUniversity}
                    onValuesChange={(changedValues,allValues)=>{
                        setUniversityFormInfo(allValues);
                    }}
                    layout='vertical'
                >

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="title" 
                        label="اسم الجامعة"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة اسم الجامعة',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="اسم الجامعة"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    <Form.Item label="مفعل" name="active" valuePropName="checked" >
                        <Switch  />
                    </Form.Item>
                    
                    <Button  style={{backgroundColor:Colors.primary, borderWidth:0}}  type="primary"  icon={<SendOutlined />} onClick={()=>{editUniversityForm.submit()}} loading={false} >
                          ارسال الطلب
                    </Button>
                    
                </Form>

            </Drawer>
        
            <GlobalHeader title={pageTitle}/>
            <Layout>
            
            <GlobalSider currentPage={'unviversities'} currentSub={'sub1'} />
            <Layout
                style={{
                padding: '0 24px 24px',
                }}
            >
                <Breadcrumb
                style={{
                    margin: '16px 0',
                }}
                >
                <Breadcrumb.Item onClick={()=>navigate('/mnghome')}  style={{cursor: 'pointer'}} >الرئيسية</Breadcrumb.Item>
                <Breadcrumb.Item>{pageTitle}</Breadcrumb.Item>
                
                
                </Breadcrumb>
                <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                }}
                >
                <Row  style={{padding:10}} >

                <Col md={24} >
                    <Button onClick={()=> setAddUniversityVisible(true) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<PlusOutlined />} size={20}>
                        اضافة  جامعة
                    </Button>
                   </Col>

                    <Col md={24} style={{marginTop:24}}>

                    <Table 
                        dataSource={universities}
                        pagination={{ position: ['bottomCenter'],total:totalCount}}
                        onChange={handleTableChange}
                        loading={addLoading}
                        scroll={{ x: '100%'}}
                    >

                    

                        <Column title="اسم الجامعه"  width="200px" key="title" 
                            render={(text, record) => (
                                <Space>
                                    {record?.title}
                                </Space>
                                
                            )}
                        />

                        <Column  width={150} title="مفعل"  key="active" 
                            render={(text, record) => (
                                <Space>
                                    {record?.active === true ? <Tag color={'green'}  >مفعل </Tag> : <Tag  color={'red'} >غير مفعل</Tag> }
                                </Space>
                            
                            )}
                             
                        /> 

                         <Column title="العمليات"  width="200px" key="status" 
                            render={(text, record) => (
                                <Space>
                                <Button onClick={()=> prepareEdit({id:record?.id,...record}) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<EditOutlined />} size={20}>
                                    تعديل
                                </Button>

                                <Button onClick={()=> showDeleteConfirm(record?.title, record?.id) } style={{backgroundColor:Colors.red, borderWidth:0}} type="primary" shape="round" icon={<DeleteOutlined />} size={20}>
                                     حذف
                                </Button>
                                </Space>
                                
                            )}
                        />
                
                    </Table>

                    </Col>
                   
                </Row>
                </Content>
            </Layout>
            </Layout>
        </Layout>
    )
}

export default MngUniversities




